import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/useTheme";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      className="stb-btn stb-btn-ghost"
      data-testid="theme-toggle"
      aria-label={isDark ? "Přepnout na denní režim" : "Přepnout na noční režim"}
      title={isDark ? "Denní režim" : "Noční režim"}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
      <span className="hidden lg:inline text-xs">
        {isDark ? "Denní" : "Noční"}
      </span>
    </button>
  );
}
